import {Component, Inject, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {QuestionnairesSurveysService} from "../../services/questionnaires-surveys.service";
import {ErrorHandlerService} from "../../services/error-handler.service";
import {SnackBarService} from "../../services/snack-bar.service";
import {Session} from "../../services/Session";
import {MatCardModule} from "@angular/material/card";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatButtonModule} from "@angular/material/button";
import {MatInputModule} from "@angular/material/input";
import {MatSidenavModule} from "@angular/material/sidenav";
import {MatTabsModule} from "@angular/material/tabs";
import {MatIconModule} from "@angular/material/icon";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatBadgeModule} from "@angular/material/badge";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatMenuModule} from "@angular/material/menu";
import {ScrollingModule} from "@angular/cdk/scrolling";
import {MatListModule} from "@angular/material/list";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MatBottomSheetModule} from "@angular/material/bottom-sheet";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatNativeDateModule, MatOptionModule} from "@angular/material/core";
import {MatSelectModule} from "@angular/material/select";
import {MatRadioModule} from "@angular/material/radio";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {DragDropModule} from "@angular/cdk/drag-drop";
import {MatTableModule} from "@angular/material/table";
import {MatSortModule} from "@angular/material/sort";
import {MatChipsModule} from "@angular/material/chips";
import {MatDividerModule} from "@angular/material/divider";
import {TextFieldModule} from "@angular/cdk/text-field";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatAutocompleteModule} from "@angular/material/autocomplete";

export interface DialogData {
  action: string;
  index: string;
  tabObj: any;
  questionnaireId: string;
  response: any;
}

@Component({
  selector: 'app-tabs-add-edit-delete-qs',
  standalone: true,
  imports: [CommonModule, FormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    MatSidenavModule,
    MatTabsModule,
    MatIconModule,
    MatCheckboxModule,
    MatToolbarModule,
    MatBadgeModule,
    MatTooltipModule,
    MatMenuModule,
    ScrollingModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatBottomSheetModule,
    MatSlideToggleModule,
    MatOptionModule,
    MatSelectModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    DragDropModule,
    MatTableModule,
    MatSortModule,
    MatDialogModule,
    MatChipsModule,
    MatDividerModule,
    TextFieldModule,
    MatExpansionModule,
    MatAutocompleteModule,
    MatSelectModule],
  templateUrl: './tabs-add-edit-delete-qs.component.html',
  styleUrl: './tabs-add-edit-delete-qs.component.scss'
})
export class TabsAddEditDeleteQsComponent implements OnInit {
  loader: boolean;
  org = Session.getOrg() ? Session.getOrg() : '';
  userId = Session.getUser().id ? Session.getUser().id : '';

  constructor(
    public dialogRef: MatDialogRef<TabsAddEditDeleteQsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private qsService: QuestionnairesSurveysService,
    private snackBar: SnackBarService,
    private errorHandler: ErrorHandlerService
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
  }

  onAdd(): void {
    this.loader = true;
    this.data.tabObj.order = this.data.index;
    this.data.tabObj.is_default = false;
    this.qsService.addTab(this.userId, this.org, this.data.questionnaireId, this.data.tabObj)
      .subscribe((response) => {
        this.onResponse(response, 'Added');
      }, error => {
        this.handleError(error);
      });
  }

  onUpdate(): void {
    this.loader = true;
    this.data.tabObj.order = this.data.index + 1;
    this.data.tabObj.is_default = false;
    this.qsService.updateTab(this.userId, this.org, this.data.questionnaireId, this.data.tabObj)
      .subscribe((response) => {
        this.onResponse(response, 'Updated');
      }, error => {
        this.handleError(error);
      });
  }

  onDelete(): void {
    this.loader = true;
    this.qsService.deleteTab(this.userId, this.org, this.data.questionnaireId, this.data.tabObj.id)
      .subscribe((response) => {
        this.onResponse(response, 'Deleted');
      }, error => {
        this.handleError(error);
      });
  }

  onResponse(response, type): void {
    this.data.response = response;
    this.dialogRef.close(this.data);
    this.snackBar.showNotification(`${type} Successfully`, 'success');
    this.loader = false;
  }

  handleError(error): void {
    this.loader = false;
    this.errorHandler.handleError(error);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
